/**
 * User type constants
 * These numeric values represent different user permission levels
 */
export const USER_TYPES = {
    FREE: 1,
    SUPPORTED: 10,
    ADMIN: 99
};

/**
 * Get user type label
 * @param {number} type - The user type number
 * @returns {string} The user type label
 */
export const getUserTypeLabel = (type) => {
    switch (type) {
        case USER_TYPES.FREE:
            return 'Free';
        case USER_TYPES.SUPPORTED:
            return 'Supported';
        case USER_TYPES.ADMIN:
            return 'Admin';
        default:
            return 'Unknown';
    }
};

